<div class="container h-full p-3">
    <div class="filter-container h-full">
        @if(!isDashboardRoute){
            <filter-drawer  [isExpanded]="true" class="block"></filter-drawer>
        }

        @else {
            <div class="flex flex-col gap-3 items-center h-full pb-20">
                <mat-form-field appearance="outline" class="p-0 w-full">
                    <mat-label>{{ 'common.date-selection.title' | transloco }}</mat-label>
                    <mat-date-range-input
                        [formGroup]="dateRangeForm"
                        [rangePicker]="picker"
                        class="w-full"
                    >
                        <input
                            matStartDate
                            formControlName="start"
                            placeholder="{{ 'common.date-selection.start-date' | transloco }}"
                            class="px-2 py-1 w-30"
                        />
                        <input
                            matEndDate
                            formControlName="end"
                            placeholder="{{ 'common.date-selection.end-date' | transloco }}"
                            class="px-2 py-1 w-30"
                        />
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <mat-button-toggle-group class="date-toggle-group flex flex-col w-full gap-5" [formControl]="dateRangeControl" [hideSingleSelectionIndicator]="true">
                    @for(option of data.dateControlOptions; track option){
                    <mat-button-toggle
                        [value]="option.value"
                        class="date-toggle"
                        [ngClass]="{
                            selected: dateRangeControl?.value === option?.value
                        }"
                    >
                        <span class="mat-button-toggle-label-content date-label text-2xl  font-semibold leading-5">{{ option.label | transloco }}</span>
                    </mat-button-toggle>
                }   
                </mat-button-toggle-group>

                <div class="flex gap-2 w-full bg-card z-10 p-4 border-t  fixed bottom-0">
                    <button class="text-gray-500 font-semibold flex-1" mat-button (click)="reset()">
                        {{ 'actions.reset' | transloco }}
                    </button>
                    <button
                        class="mr-4 font-semibold	 flex-1"
                        mat-flat-button
                        [color]="'accent'"
                        (click)="save(dateRangeControl)"
                    >
                    {{ 'actions.save' | transloco }}
                    </button>
                </div>

                
            </div>
        }
    </div>
</div>